module.exports = "https://cdn.hellotech.com/client-assets/mobile-desktop_480ae69574638f642ca87a12298d2207.jpg";